import React from 'react'
import _ from 'lodash'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import { cyan500 } from 'material-ui/styles/colors';


class ItemInfo extends React.Component {

  render() {
    const { item, styles, handleChange, handleProductChange, products, handleUploadedImage, required, disableFields, dropzoneStyles, client } = this.props
    const productSelect = _.map(products, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    return (
      <div>
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          inputStyle={styles.inputStyle}
          value={item.id}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={item.name}
          name="name"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyle}
          errorText={required.name}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Folder Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          inputStyle={styles.inputStyle}
          value={item.foldername || ''}
          name="foldername"
          onChange={!disableFields ? handleChange : ''}
        />
        <TextField
          floatingLabelText="SKU"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={item.sku}
          name="sku"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyle}
          errorText={required.sku}
          errorStyle={{ color: cyan500 }}
        />
        <SelectField
          value={item.productId}
          onChange={!disableFields ? handleProductChange : ''}
          floatingLabelText="Product"
          name="productId"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          floatingLabelStyle={styles.floatingLabelStyle}
        >
          <MenuItem value={null} primaryText="" />
          {productSelect}
        </SelectField>
        <TextField
          floatingLabelText="MSRP"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={item.msrp}
          name="msrp"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Image"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={item.img}
          name="img"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyleLarge}
        />
        <button
          className="filestack-button"
          onClick={(e) => {
            e.preventDefault;
            return client.picker({
              uploadInBackground: false,
              onUploadDone: ((res) => {
                console.log('RES FROM FILESTACK', res);
                const targetName = 'img'
                const targetValue = res.filesUploaded[0].url
                handleUploadedImage(targetName, targetValue)
              })
            }).open()
          }}
          style={dropzoneStyles}>
          <p className="filestack-uplaod">Filestack Upload Image</p>
        </button>
        <br />
        <br />
        <br />
        <ul>
          <li>
            <Checkbox
              label="Disabled"
              defaultChecked={item.disabled}
              name="disabled"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
          <li>
            <Checkbox
              label="Out of Stock"
              defaultChecked={item.outOfStock}
              name="outOfStock"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
          <li>
            <Checkbox
              label="Sage Manufactured"
              defaultChecked={item.sageManufactured}
              name="sageManufactured"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
        </ul>
        <br />
        <br />
      </div>
    )
  }

}

export default ItemInfo


// WEBPACK FOOTER //
// ./src/components/items/Common/ItemInfo.js